export default {};
//# sourceMappingURL=SideSheet.js.map